import type { DomainType } from '../../types/reporting';
import {
    getOverviewBundleLocationId,
} from './reportingBundleDomainStats';
import { useDomainStats, type DomainStatsHookOptions } from './useDomainStats';

export type ReportingDomainStatsOptions = DomainStatsHookOptions & {
    granularity?: 'day' | 'week' | 'biweekly' | 'month';
};

/**
 * Domain tabs and overview widgets: always POST /domain/stats.
 */
export function useReportingDomainStats(
    domain: DomainType,
    startDate: string,
    endDate: string,
    options?: ReportingDomainStatsOptions,
) {
    const {
        enabled = true,
        groupBy,
        sortBy = 'orderVolume',
        sortOrder = 'desc',
        limit,
        locationId,
        preset,
        comparison,
        excludeEvs,
    } = options ?? {};

    const bundleLocationId = domain === 'location'
        ? getOverviewBundleLocationId(undefined)
        : getOverviewBundleLocationId(locationId);

    const domainStatsQuery = useDomainStats(domain, startDate, endDate, {
        locationId: bundleLocationId,
        sortBy,
        sortOrder,
        limit,
        preset,
        comparison,
        excludeEvs,
        groupBy,
        enabled,
    });

    return {
        data: domainStatsQuery.data,
        isLoading: domainStatsQuery.isLoading,
        isFetching: domainStatsQuery.isFetching,
        source: 'domain' as const,
    };
}
